// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ixeq","option":"styles_option__1cjFG","active":"styles_active__3H1X3"};